import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance,
  API_END_POINTS,
  axiosNoAuthInstance,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  EVENT_PAGES,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchEventPages = async (payload) => {
  const query = generateQuery(payload.currentPage);
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  const seated = payload.seated ? payload.seated : 'seated=false';
  if (payload.filterParams && !payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_EVENT_PAGE}?${seated}&${payload.filterParams}`);
  }
  if (payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_EVENT_PAGE}${query}${sorting}&${seated}&${payload.filterParams}`);
  }
  if (!payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_EVENT_PAGE}${query}${sorting}&${seated}`);
  }
  return axiosAuthInstance.get(`${API_END_POINTS.GET_EVENT_PAGE}${query}${sorting}&${seated}`);
};

const postEventPage = async params => axiosAuthInstance.post(API_END_POINTS.GET_EVENT_PAGE, params);

const patchEventPage = async ({ gid, params }) => axiosAuthInstance.patch(`${API_END_POINTS.UPDATE_CUSTOMERS}/${gid}`, params);

const deleteEventPageAPI = async ({ gid }) => axiosAuthInstance.delete(`${API_END_POINTS.GET_EVENTS}/${gid}`);

const fetchEventPageReceipts = async gid => axiosNoAuthInstance.get(`${API_END_POINTS.EVENT_PAGE_ORDER_RECEIPT}?orderGid=${gid}`);

export function* getEventPages(action) {
  try {
    const { data: { entity } } = yield call(fetchEventPages, action.payload);
    yield put({ type: EVENT_PAGES.SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: EVENT_PAGES.FAILED, payload: e.response.data });
  }
}

export function* addEventPage(action) {
  try {
    yield put({ type: LOADING.SET });
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(postEventPage, action.payload);
    // yield put({
    //   type: NOTIFICATION.SUCCESS,
    //   payload: MESSAGES.EVENTS.ADD_SUCCESS,
    // });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
    yield put({ type: LOADING.UNSET });
  }
}

export function* updateEventPage(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(patchEventPage, action.payload);
    const { data: { entity } } = yield call(fetchEventPages, action.payload);
    yield put({ type: EVENT_PAGES.SUCCESS, payload: entity });
    // yield put({
    //   type: NOTIFICATION.SUCCESS,
    //   payload: MESSAGES.EVENTS.UPDATE_SUCCESS,
    // });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}

export function* deleteEventPage(action) {
  try {
    yield put({ type: LOADING.VALIDATING });
    yield put({ type: LOADING.SUBMITTING });
    yield call(deleteEventPageAPI, action.payload);
    const { data: { entity } } = yield call(fetchEventPages, action.payload);
    yield put({ type: EVENT_PAGES.SUCCESS, payload: entity });
    // yield put({
    //   type: NOTIFICATION.SUCCESS,
    //   payload: MESSAGES.EVENTS.DELETE_SUCCESS,
    // });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}

export function* getEventPageReceipts(action) {
  try {
    yield put({ type: LOADING.SET });
    const { data: { entity } } = yield call(fetchEventPageReceipts, action.payload);
    yield put({ type: EVENT_PAGES.RECEIPT_SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.UNSET });
  }
}
